import {DateTimeFormat} from '@hconnect/common/components'
import {Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

type Props = {
  timezone: string
  label?: string
  userName?: string
  date?: string
  'data-test-id'?: string
}

export const MetaAnnotation: React.FC<Props> = ({
  label,
  userName,
  date,
  timezone,
  'data-test-id': dataTestId
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <Typography gutterBottom variant="caption" data-test-id={dataTestId}>
      {label && `${label} `}
      {userName && `${userName} `}
      {date && (
        <>
          {t('metaAnnotation.label.happenOn')} <DateTimeFormat date={date} timezone={timezone} />
        </>
      )}
    </Typography>
  )
}
